import React from 'react';
import { motion } from 'framer-motion';
import { StarFlourish } from './Decorations';
export function Programme() {
  const acts = [{
    time: '10:15 AM',
    name: 'The Setup',
    title: 'How We Got Here',
    desc: 'A short history of how web development has evolved — from hand-written HTML to component libraries to AI-assisted workflows. Where the real bottlenecks have always been, and why this moment is different.'
  }, {
    time: '11:00 AM',
    name: 'The Trick',
    title: 'AI in Practice — A Live Demo',
    desc: 'A working session: building a real interface from a prompt, refactoring legacy code, and shipping changes — all with AI tools in the loop. We will look at what works, what does not, and where human judgement still matters most.'
  }, {
    time: '11:45 AM',
    name: 'The Reveal',
    title: 'What This Means for Your Team',
    desc: 'Practical takeaways: how roles are shifting, what to invest in, and the questions every business should be asking. Followed by open Q&A with the audience.'
  }];
  return <section className="py-24 px-4 relative" data-id="element-108">
      <div className="max-w-4xl mx-auto" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-velvet text-parchment rounded-sm p-8 md:p-16 relative shadow-2xl" data-id="element-110">
          {/* Playbill styling */}
          <div className="absolute inset-2 border-2 border-parchment/10 rounded-sm pointer-events-none" data-id="element-111" />
          <div className="absolute inset-3 border border-parchment/5 rounded-sm pointer-events-none" data-id="element-112" />

          <div className="text-center mb-12" data-id="element-113">
            <h2 className="text-sm uppercase tracking-[0.3em] text-carrot font-bold mb-4 text-glow-carrot" data-id="element-114">
              The Morning's
            </h2>
            <h3 className="text-5xl md:text-6xl font-serif text-parchment" data-id="element-115">
              Programme
            </h3>
            <div className="flex justify-center gap-2 mt-6 text-carrot" data-id="element-116">
              <StarFlourish className="w-4 h-4" data-id="element-117" />
              <StarFlourish className="w-4 h-4" delay={0.5} data-id="element-118" />
              <StarFlourish className="w-4 h-4" delay={1} data-id="element-119" />
            </div>
          </div>

          <div className="space-y-12" data-id="element-120">
            {acts.map((act, index) => <div key={index} className="relative pl-8 md:pl-0 md:flex md:gap-8 items-start group" data-id="element-121">
                <div className="hidden md:block w-32 text-right pt-1" data-id="element-122">
                  <span className="font-serif text-xl text-carrot" data-id="element-123">
                    {act.time}
                  </span>
                </div>

                {/* Mobile time */}
                <div className="md:hidden absolute left-0 top-1 w-2 h-2 rounded-full bg-carrot" data-id="element-124" />
                <div className="md:hidden text-carrot font-serif text-lg mb-1" data-id="element-125">
                  {act.time}
                </div>

                <div className="flex-1 md:border-l-2 border-parchment/10 md:pl-8 pb-8 md:pb-0 border-dashed group-last:border-transparent" data-id="element-126">
                  <h4 className="text-2xl md:text-3xl font-serif mb-1" data-id="element-127">
                    {act.name}
                  </h4>
                  <p className="text-sm uppercase tracking-widest text-parchment/60 mb-3 font-medium" data-id="element-128">
                    {act.title}
                  </p>
                  <p className="text-parchment/80 leading-relaxed" data-id="element-129">
                    {act.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}